
import styled from "styled-components";
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import TableCell from '@mui/material/TableCell';
import {useState,Fragment} from "react";
import Card from "../../juegos/card.jsx"
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import ReventaConfigPrices from "../usuariosAdmin/addGame/reventaConfigPrices.jsx";
import CloseIcon from '@mui/icons-material/Close';


const ContainerCard=styled.div`
	display:flex;
	height:80px;
	width:80px
`;

let ContainerConfigPrices=styled.div`
	position:absolute;
	height:80vh;
	width:100vw;
	top:5%

`;
 let CloseConfigPrices=styled.div`
 	width:95%;
 	display:flex;
 	justify-content:end;


 `;

export default function RowTableCuentas(props) {
  const { row ,isItemSelected} = props;
  let [configPrices,setConfigPrices]=useState(false);
  let [load,setLoad]=useState(false)

  let revender=(id)=>{
  	setConfigPrices(true)
  }


  return(
  		<Fragment>
  		{row?			
            <TableRow   hover role="checkbox" aria-checked={isItemSelected} tabIndex={-1}  selected={isItemSelected} sx={{ cursor: 'pointer' }}>
  			{configPrices?
  				<ContainerConfigPrices >
  					<CloseConfigPrices>
  						<CloseIcon onClick={()=>setConfigPrices(false)} />
  					</CloseConfigPrices>
            		<ReventaConfigPrices reventa={row} setReventaSave={(reventa)=>{console.log(reventa)}} setOpen={setConfigPrices} setLoad={setLoad} poster={row.juegoPoster} consola={row.juegoConsola} />
            	</ContainerConfigPrices>
            :null} 
                <TableCell>
                	<ContainerCard>
                   		<Card poster={row.juegoPoster} consola={row.juegoConsola}/>
                  	</ContainerCard>
                </TableCell>
                <TableCell  sx={{fontSize:"12px"}}>{row.id}</TableCell>
                <TableCell  sx={{fontSize:"12px"}}>{row.nombre}</TableCell>
                <TableCell  sx={{fontSize:"12px"}}>{row.usuario}</TableCell>
                <TableCell  sx={{fontSize:"12px"}}>{row.playstationID}</TableCell> 
                <TableCell  sx={{fontSize:"12px"}}>{row.correoPlaystation}</TableCell>
                <TableCell  sx={{fontSize:"12px"}}>{row.fechaCreacion}</TableCell>
                <TableCell align="center" >
                  	<IconButton  size="small" >
            	 		<PointOfSaleIcon sx={{color:"#21D014"}} onClick={revender} /> 
          			</IconButton>
       			</TableCell>
       			   
            </TableRow>
           :null}  
                    	
		 </Fragment>




  	)}